import type { CSSProperties } from "react";
import type { TaskUrgency } from "../../tarefas/tarefasApi";

// Peças visuais partilhadas pela lista e pelo calendário das Tarefas.

// ---- Cores ------------------------------------------------------------------------------------
// Inline porque o index.css é Tailwind pré-compilado. Vão em variáveis com uma versão para o
// tema escuro: texto escuro fixo sobre um fundo escuro ficava ilegível.
export const TONE_STYLES = `
.tarefas-root {
  --tt-blue-bg: rgba(37,99,235,0.14); --tt-blue-fg: #1d4ed8;
  --tt-purple-bg: rgba(147,51,234,0.14); --tt-purple-fg: #7e22ce;
  --tt-green-bg: rgba(22,163,74,0.14); --tt-green-fg: #166534;
  --tt-red-bg: rgba(220,38,38,0.12); --tt-red-fg: #b91c1c;
  --tt-today-bg: rgba(245,158,11,0.16); --tt-today-fg: #92400e;
  --tt-urgent-bg: #fef3c7; --tt-urgent-fg: #92400e;
  --tt-very-bg: #7c2d12; --tt-very-fg: #ffffff;
  --tt-accent-text: #c2410c;
}
.dark .tarefas-root {
  --tt-blue-bg: rgba(59,130,246,0.22); --tt-blue-fg: #93c5fd;
  --tt-purple-bg: rgba(168,85,247,0.22); --tt-purple-fg: #d8b4fe;
  --tt-green-bg: rgba(34,197,94,0.20); --tt-green-fg: #86efac;
  --tt-red-bg: rgba(239,68,68,0.22); --tt-red-fg: #fca5a5;
  --tt-today-bg: rgba(245,158,11,0.22); --tt-today-fg: #fcd34d;
  --tt-urgent-bg: #78350f; --tt-urgent-fg: #fde68a;
  --tt-very-bg: #9a3412; --tt-very-fg: #ffffff;
  --tt-accent-text: #fdba74;
}
`;

export const URGENCY_OPTIONS: { value: TaskUrgency; label: string; style: CSSProperties; accent: string }[] = [
  { value: "Normal", label: "Normal", style: {}, accent: "transparent" },
  { value: "Urgent", label: "Urgente", style: { backgroundColor: "var(--tt-urgent-bg)", color: "var(--tt-urgent-fg)" }, accent: "#f59e0b" },
  { value: "VeryUrgent", label: "Muito urgente", style: { backgroundColor: "var(--tt-very-bg)", color: "var(--tt-very-fg)" }, accent: "#9a3412" },
];

export const segmentButton = (selected: boolean, selectedStyle?: CSSProperties): CSSProperties => ({
  padding: "6px 12px",
  fontSize: "var(--text-sm)",
  border: "1px solid var(--border)",
  marginLeft: -1,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  background: selected ? "var(--primary)" : "var(--background)",
  color: selected ? "var(--primary-foreground)" : "var(--foreground)",
  fontWeight: selected ? 600 : 400,
  ...(selected ? selectedStyle : {}),
});

export const fieldLabel: CSSProperties = {
  fontSize: "var(--text-xs)",
  color: "var(--secondary-text)",
  fontWeight: 600,
  marginBottom: 4,
};

export const segmentRadius = (index: number, count: number) =>
  index === 0
    ? "var(--radius-button) 0 0 var(--radius-button)"
    : index === count - 1
      ? "0 var(--radius-button) var(--radius-button) 0"
      : 0;
